import { render, staticRenderFns } from "./section_2.vue?vue&type=template&id=49d6a17a&scoped=true&"
import script from "./section_2.vue?vue&type=script&lang=js&"
export * from "./section_2.vue?vue&type=script&lang=js&"
import style0 from "./section_2.vue?vue&type=style&index=0&id=49d6a17a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d6a17a",
  null
  
)

component.options.__file = "section_2.vue"
export default component.exports